var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.jackpot > 10000)?_c('section',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.t.bet_jackpot_info),expression:"t.bet_jackpot_info"}],staticClass:"EventCards-styles-event-cards-wrapper"},[_c('h1',{attrs:{"id":"betpot"}},[_vm._v("0.00.0")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.t.weekly_bet_jackpot || 'Weekly BetPot'))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-234f08ac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widget/betPot.vue
// module id = 1cwt
// module chunks = 0